import React, { useState, useMemo } from 'react';
import DataTableV3 from 'src/components/DataTableV3';
import { eeaArticleColumns } from '../constants/eea-article-columns';
import { EeaArticleDto } from 'src/api/v2';
import { Button } from '@innovationnorway/cl-react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { RowSelectionState } from '@tanstack/react-table';
import { EeaData } from '../hooks/subforms/use-eea-form';

type Props = {
  setValue: UseFormSetValue<EeaData>;
  getValues: UseFormGetValues<EeaData>;
  eeaArticles?: EeaArticleDto[];
  isLoading?: boolean;
  close: () => void;
};

const SelectEeaArticleTable: React.FC<Props> = ({ getValues, setValue, eeaArticles, isLoading, close }) => {
  const [selected, setSelected] = useState<EeaArticleDto[]>([]);

  const preselectedRows = useMemo(() => {
    const preSelected = getValues('selectedEeaArticles')?.map((eea) => eea.eeaArticleId) || [];
    return eeaArticles?.reduce((acc, eea, index) => {
      if (preSelected.includes(eea.id)) {
        acc[index] = true;
      }
      return acc;
    }, {} as RowSelectionState);
  }, [eeaArticles, getValues]);

  return (
    <div>
      <DataTableV3
        disableColumnEditor
        disableGlobalFilter
        disableExport
        hideFilterText
        setSelectedRows={setSelected}
        data={eeaArticles!}
        columns={eeaArticleColumns}
        id={'eeaArticles'}
        preselectedRows={preselectedRows}
        loading={isLoading}
      />
      <div className="display--flex gap--2">
        <Button
          onClick={() => {
            if (selected.length > 0) {
              setValue(
                'selectedEeaArticles',
                selected.map((article) => ({
                  eeaArticleId: article.id,
                })),
              );
            } else {
              setValue('selectedEeaArticles', []);
            }
            close();
          }}
        >
          Legg til
        </Button>
        <Button variant="secondary" onClick={() => close()}>
          Avbryt
        </Button>
      </div>
    </div>
  );
};

export default SelectEeaArticleTable;
